import React, { useContext, useState } from 'react'
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import axios from 'axios';
import { AuthContext } from '../contexts/AuthContext';

function Auth() {
    const navigate = useNavigate();
    const { jwtUser } = useContext(AuthContext);
    const [signInfo, setSignInfo] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        // Checkbox üçün xüsusi hal
        if (type === 'checkbox') {
            setSignInfo((prev) => ({
                ...prev,
                [name]: checked, // checkbox-da checked və ya unchecked dəyəri
            }));
        } else {
            setSignInfo((prev) => ({
                ...prev,
                [name]: value,
            }));
        }

        console.log(signInfo);
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    }

    const handleSignIn = () => {
        axios.post('https://elnaf.fi/new/api/login.php', JSON.stringify(signInfo), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        })
            .then(response => {
                const data = response.data;

                if (jwtUser(data.token, signInfo.remember)) {
                    navigate('/');
                }
            })
            .catch(error => {
                console.error(error);
            });
    }
    return (
        <div className="card custom-card my-4 border z-3 position-relative">
            <div className="card-body p-0">
                <div className="p-5">
                    <div className="d-flex align-items-center justify-content-center mb-3">
                        <span className="auth-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" id="password"><path fill="#6446fe" d="M59,8H5A1,1,0,0,0,4,9V55a1,1,0,0,0,1,1H59a1,1,0,0,0,1-1V9A1,1,0,0,0,59,8ZM58,54H6V10H58Z" className="color1d1f47 svgShape" /><path fill="#6446fe" d="M36,35H28a3,3,0,0,1-3-3V27a3,3,0,0,1,3-3h8a3,3,0,0,1,3,3v5A3,3,0,0,1,36,35Zm-8-9a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V27a1,1,0,0,0-1-1Z" className="color0055ff svgShape" /><path fill="#6446fe" d="M36 26H28a1 1 0 0 1-1-1V24a5 5 0 0 1 10 0v1A1 1 0 0 1 36 26zm-7-2h6a3 3 0 0 0-6 0zM32 31a1 1 0 0 1-1-1V29a1 1 0 0 1 2 0v1A1 1 0 0 1 32 31z" className="color0055ff svgShape" /><path fill="#6446fe" d="M59 8H5A1 1 0 0 0 4 9v8a1 1 0 0 0 1 1H20.08a1 1 0 0 0 .63-.22L25.36 14H59a1 1 0 0 0 1-1V9A1 1 0 0 0 59 8zm-1 4H25l-.21 0a1.09 1.09 0 0 0-.42.2L19.73 16H6V10H58zM50 49H14a1 1 0 0 1-1-1V39a1 1 0 0 1 1-1H50a1 1 0 0 1 1 1v9A1 1 0 0 1 50 49zM15 47H49V40H15z" className="color1d1f47 svgShape" /><circle cx="19.5" cy="43.5" r="1.5" fill="#6446fe" className="color0055ff svgShape" /><circle cx="24.5" cy="43.5" r="1.5" fill="#6446fe" className="color0055ff svgShape" /><circle cx="29.5" cy="43.5" r="1.5" fill="#6446fe" className="color0055ff svgShape" /><circle cx="34.5" cy="43.5" r="1.5" fill="#6446fe" className="color0055ff svgShape" /><circle cx="39.5" cy="43.5" r="1.5" fill="#6446fe" className="color0055ff svgShape" /><circle cx="44.5" cy="43.5" r="1.5" fill="#6446fe" className="color0055ff svgShape" /><path fill="#6446fe" d="M60 9a1 1 0 0 0-1-1H28.81l2.37-2.37A19.22 19.22 0 0 1 60 31zM35.19 56l-2.37 2.37A19.22 19.22 0 0 1 4 33V55a1 1 0 0 0 1 1z" opacity=".3" className="color0055ff svgShape" /></svg>
                        </span>
                    </div>
                    <p className="h4 fw-semibold mb-0 text-center">Sign In</p>
                    <p className="mb-3 text-muted fw-normal text-center">Welcome back Jhon !</p>
                    <div className="row gy-3">
                        <div className="col-xl-12">
                            <label htmlFor="signup-firstname" className="form-label text-default">User Name or Email</label>
                            <div className="position-relative">
                                <input type="text" onChange={handleInputChange} value={signInfo.emailOrUsername || ''} name='emailOrUsername' className="form-control form-control-lg" id="signup-firstname" placeholder="Enter User Name or Email" />
                            </div>
                        </div>
                        <div className="col-xl-12 mb-2">
                            <label htmlFor="signin-password" className="form-label text-default d-block">Password</label>
                            <div className="position-relative">
                                <input type={showPassword ? "text" : "password"} onChange={handleInputChange} value={signInfo.password || ''} name='password' className="form-control form-control-lg" id="signin-password" placeholder="Password" />
                                <button style={{ border: 'none' }} className="show-password-button text-muted" onClick={togglePasswordVisibility} id="button-addon2"><i className="ri-eye-off-line align-middle" /></button>
                            </div>
                            <div className="mt-2">
                                <div className="form-check">
                                    <input onChange={handleInputChange} className="form-check-input" name='remember' type="checkbox" checked={signInfo.remember || false} id="defaultCheck1" />
                                    <label className="form-check-label text-muted fw-normal fs-12" htmlFor="defaultCheck1">
                                        Remember password ?
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-grid mt-4">
                        <button onClick={handleSignIn} disabled={signInfo && signInfo.emailOrUsername && (signInfo.password && signInfo.password.length > 7) ? false : true} className="btn btn-primary">Sign In</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Auth